import util from '@bmp-vue/core/api/util'

const controller = 'LancamentosFuturos'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'delete']), {
  GetLancamentosFuturos: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  DetalhesTransacao: function (id) {
    return util.Axios.Get(controller + '/DetalhesTransacao', id)
  },
})
